export const DEFAULT_TITLE = 'Comments';
export const DEFAULT_FILTER_DOMAIN = '0';
export const NEW_COMMENT_ID = 'new_comment';
export const DEFAULT_HISTORICAL_LABEL = 'Previous';
